import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";

type Props = {
    label: string,
    translationDomain: TranslationDomainEnum,
    onClick: () => void
}

export const ResetType: React.FC<Props> = ({label, translationDomain, onClick}) => {
    return (
        <Button type="default" onClick={() => { onClick() }}>
            <Translate message={label ?? `global.button.reset`} domain={translationDomain ?? TranslationDomainEnum.MESSAGES} />
        </Button>
    )
}